import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { shouldStatusExecute } from '../../reducers/utils/state-manager';
import { accountSelector, accountsStatusSelector } from '../account-selectors';

import * as Api from '../../api/api';

export const loadAccount = (accountId: number) =>
  createGenericDispatcher<TeamEngineAccount>({
    name: 'LOAD_ACCOUNT',
    loadFunction: () => Api.get(`/account/${accountId}`),
    args: { accountId },
    shouldExecute: (state: any) => {
      const directLoadStatus = accountsStatusSelector(state, accountId);
      const account = accountSelector(state, accountId);
      return shouldStatusExecute(directLoadStatus, Boolean(account));
    },
  });
